export function NinetyMinutes() {
  return (
    <section data-testid="ninety-minutes-section" className="relative overflow-hidden bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[47px] sm:pt-[61px] lg:pt-[82px] pb-[38px] md:pb-[55px]">
        <div className="reveal">
          <h2 className="font-display text-[36px] sm:text-[48px] lg:text-[54px] leading-[1.05] tracking-tight text-[#1C1917] text-center max-w-3xl mx-auto mb-6">
            Imagine Ninety Minutes That Actually Belong to You.
          </h2>

          <p className="text-lg md:text-xl text-[#57534E] leading-relaxed text-center max-w-3xl mx-auto mb-14">
            Just a simple rhythm that helps you begin.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 max-w-3xl mx-auto">
            <div className="border-t border-[#E8E6E3] pt-5 space-y-4">
              <p className="text-[18px] text-[#57534E] leading-relaxed">No pressure to perform.</p>
              <p className="text-[18px] text-[#57534E] leading-relaxed">No awkward introductions.</p>
              <p className="text-[18px] text-[#57534E] leading-relaxed">No lectures.</p>
              <p className="text-[18px] text-[#57534E] leading-relaxed">No guilt if life interrupted.</p>
            </div>

            <div className="border-t border-[#E8E6E3] pt-5 space-y-4">
              <p className="text-[18px] text-[#57534E] leading-relaxed">We start together.</p>
              <p className="text-[18px] text-[#57534E] leading-relaxed">Set one meaningful intention.</p>
              <p className="text-[18px] text-[#57534E] leading-relaxed">Work quietly.</p>
              <p className="text-[18px] text-[#57534E] leading-relaxed">Celebrate what moved before we leave.</p>
            </div>
          </div>

          <p className="font-display text-3xl lg:text-[46px] text-[#1C1917] leading-snug text-center max-w-3xl mx-auto mt-[32px]">
            It&rsquo;s amazing what can happen when someone simply creates space for you to begin.
          </p>
        </div>
      </div>
    </section>
  );
}
